import MainSectionLeft from 'components/desktop/detail/main-section/main-section-left';
import MainSectionRight from 'components/desktop/detail/main-section/main-section-right';

const MainSection = () => (
  <div
    id='main-section'
    className='container mx-auto flex min-w-[1052px] space-x-[24px] px-[54px] screen-1140:px-[98px] xl:px-[48px] screen-1366:px-[83px]'
  >
    <MainSectionLeft />
    <MainSectionRight />
  </div>
);

export default MainSection;
